import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		marginBottom: SPACE[32],
		width: '100%',
	},
	containerSmallDistance: {
		marginBottom: SPACE[4],
	},
	content: {
		background: THEME.colors.background.light,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		padding: SPACE[20],
		position: 'relative',
	},
	header: {
		color: THEME.colors.text.main,
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.lg,
		fontWeight: fontWeights.bold,
		margin: 0,
		marginBottom: SPACE[12],
	},
	splashScreen: {
		alignItems: 'center',
		background: 'rgba(255, 255, 255, .8)',
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
		zIndex: 10,
	},
});
